import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

export interface FlowDataStore {
  address: any;
  setAddress: (address: any) => void;

  flowData: any;
  setFlowData: (flowData: any) => void;
}

export const useFlowDataStore = create<FlowDataStore>()(
  devtools(
    persist(
      (set, _get) => ({
        address: null,
        setAddress: (address) => set({ address }),

        flowData: null,
        setFlowData: (flowData: any) => {
          set({ flowData });
        },
      }),
      {
        name: 'flow',
      },
    ),
  ),
);
